// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-771e8f65] {\n  border: 1px solid black;\n  border-collapse: collapse;\n  width: 100%;\n  text-align: center;\n}\n.selectLabel[data-v-771e8f65]  .el-input__inner {\n  height: 28px !important;\n  line-height: 28px !important;\n  border: none;\n  font-weight: bold;\n  text-align: left;\n  padding: 0;\n}\n.selectLabel[data-v-771e8f65]  .el-input__icon {\n  line-height: 28px !important;\n}", ""]);
// Exports
module.exports = exports;
